module.exports = __webpack_public_path__ + "img/mastercard.15996713.png";